import { render, staticRenderFns } from "./BankaHacizForm.vue?vue&type=template&id=307f155d"
import script from "./BankaHacizForm.vue?vue&type=script&lang=ts"
export * from "./BankaHacizForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports